/* Marine Chandlery — Conversion Boosters (loaded after mc-enhancements.js) */
(function(){
  'use strict';

  /* ---------------- styles ---------------- */
  var CSS = [
    /* finance line */
    '.mc-fin{display:flex;gap:9px;align-items:flex-start;margin:12px 0;padding:11px 13px;border:1px solid #dbe4ec;background:#f4f8fb;border-radius:11px;font-size:13.5px;line-height:1.45;color:#16324a}',
    '.mc-fin svg{flex-shrink:0;color:#1E4FC2;margin-top:1px}',
    '.mc-fin b{color:#16324a}',
    '.mc-fin a{color:#F5741F;font-weight:700;text-decoration:none;white-space:nowrap}',
    '.mc-fin a:hover{text-decoration:underline}',
    '.mc-fin small{display:block;color:#7d8a97;font-size:11px;margin-top:2px}',
    /* trust badges */
    '.mc-trust{display:grid;grid-template-columns:1fr 1fr;gap:11px 16px;margin:16px 0 4px;padding:15px 0 2px;border-top:1px solid #e6ebf0}',
    '.mc-trust__i{display:flex;gap:8px;align-items:center;font-size:12.5px;line-height:1.25;color:#33475b;font-weight:600}',
    '.mc-trust__i svg{flex-shrink:0;color:#16324a}',
    /* cross-sell */
    '.mc-xs{padding:34px 16px;background:#fff}',
    '.mc-xs__wrap{max-width:1200px;margin:0 auto}',
    '.mc-xs__h{font-size:22px;font-weight:800;color:#16324a;margin:0 0 18px;letter-spacing:-.01em}',
    '.mc-xs__grid{display:grid;grid-template-columns:repeat(4,1fr);gap:16px}',
    '.mc-xs__card{display:flex;flex-direction:column;text-decoration:none;border:1px solid #e6ebf0;border-radius:14px;overflow:hidden;background:#fff;transition:box-shadow .15s,transform .15s}',
    '.mc-xs__card:hover{box-shadow:0 8px 22px rgba(20,35,58,.10);transform:translateY(-2px)}',
    '.mc-xs__imgw{display:block;aspect-ratio:1/1;background:#f6f8fa;padding:12px;box-sizing:border-box}',
    '.mc-xs__imgw img{width:100%;height:100%;object-fit:contain;display:block}',
    '.mc-xs__t{font-size:13.5px;line-height:1.35;color:#14233a;font-weight:600;padding:2px 13px 0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;min-height:2.7em}',
    '.mc-xs__p{font-size:15px;font-weight:800;color:#16324a;padding:6px 13px 14px}',
    '@media(max-width:900px){.mc-xs__grid{grid-template-columns:1fr 1fr}}',
    /* sticky mobile add-to-cart */
    '.mc-sticky{position:fixed;left:0;right:0;bottom:0;z-index:9998;display:none;align-items:center;gap:11px;padding:9px 13px calc(9px + env(safe-area-inset-bottom));background:#fff;border-top:1px solid #e2e8ee;box-shadow:0 -6px 20px rgba(20,35,58,.12)}',
    '.mc-sticky img{width:44px;height:44px;object-fit:contain;border-radius:8px;background:#f6f8fa;flex-shrink:0}',
    '.mc-sticky__i{display:flex;flex-direction:column;min-width:0;flex:1}',
    '.mc-sticky__t{font-size:12.5px;color:#33475b;font-weight:600;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.mc-sticky__p{font-size:15px;font-weight:800;color:#16324a}',
    '.mc-sticky__btn{flex-shrink:0;background:#F5741F;color:#fff;border:0;font-weight:800;font-size:15px;padding:12px 20px;border-radius:10px;cursor:pointer}',
    '.mc-sticky__btn:active{background:#e0640f}',
    '@media(max-width:767px){.mc-sticky.is-on{display:flex}}',
    /* back-in-stock capture (inside order-in panel) */
    '.mc-bis{display:flex;gap:7px;margin:10px 0 2px;flex-wrap:wrap}',
    '.mc-bis input{flex:1;min-width:150px;border:1px solid #e2c9a6;border-radius:9px;padding:11px 12px;font-size:14px;background:#fff;color:#3a2c17}',
    '.mc-bis input:focus{outline:2px solid #F5741F;outline-offset:0;border-color:#F5741F}',
    '.mc-bis button{background:#F5741F;color:#fff;border:0;font-weight:800;font-size:14px;padding:11px 18px;border-radius:9px;cursor:pointer;white-space:nowrap}',
    '.mc-bis button:hover{background:#e0640f}',
    '.mc-bis__ok{font-size:13.5px;font-weight:700;color:#1c7a3f;margin:10px 0 2px;line-height:1.4}'
  ].join('');
  var st=document.createElement('style'); st.textContent=CSS; (document.head||document.documentElement).appendChild(st);

  var onProduct = /\/products\//.test(location.pathname);

  /* ---------------- helpers ---------------- */
  function esc(s){return (s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
  function money(p){return '£'+(p/100).toLocaleString('en-GB',{minimumFractionDigits:2,maximumFractionDigits:2});}
  function fixImg(u){u=u||'';if(u.indexOf('//')===0)u='https:'+u;return u;}
  function metaP(){try{return window.meta&&window.meta.product;}catch(e){return null;}}

  var PROD=null,PRODP=null;
  function getProduct(){
    if(PRODP)return PRODP;
    var m=metaP(); var h=m&&m.handle;
    if(!h){PRODP=Promise.resolve(null);return PRODP;}
    PRODP=fetch('/products/'+h+'.js').then(function(r){return r.json();}).then(function(p){PROD=p;return p;}).catch(function(){return null;});
    return PRODP;
  }
  function atcAny(){return document.querySelector('.pd3__atc, .cfg__btn-atc, form[action*="/cart/add"] [name="add"], form[action*="/cart/add"] button[type="submit"]');}
  function realATC(){return document.querySelector('.pd3__atc:not(.pd3__atc--oos), .cfg__btn-atc:not([disabled]), form[action*="/cart/add"] [name="add"]:not([disabled]), form[action*="/cart/add"] button[type="submit"]:not([disabled])');}

  function icon(p){return '<svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">'+p+'</svg>';}

  /* ---------------- A. finance / spread the cost ---------------- */
  function finance(){
    if(!PROD||!PROD.available)return;
    if(PROD.price<30000)return; /* only >= £300 */
    var btn=atcAny(); if(!btn)return;
    var b=btn.closest('.pd3__purchase')||btn;
    var host=b.parentNode; if(!host||host.querySelector('.mc-fin'))return;
    var mo=Math.ceil(PROD.price/100/24);
    var el=document.createElement('div'); el.className='mc-fin';
    el.innerHTML=icon('<circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path>')+
      '<span>Spread the cost — e.g. around <b>£'+mo+'/mo</b> over 24 months. <a href="/pages/contact">Ask about finance →</a>'+
      '<small>Illustrative only, not a credit offer. Finance subject to status &amp; approval.</small></span>';
    host.insertBefore(el,b);
  }

  /* ---------------- B. trust badges ---------------- */
  var TRUST=[
    ['<path d="M12 3l7 4v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V7z"></path><path d="M9 12l2 2 4-4"></path>','Authorised UK dealer'],
    ['<path d="M12 3l7 4v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V7z"></path>','Full manufacturer warranty'],
    ['<path d="M14.7 6.3a4 4 0 0 0-5.4 5.4l-6 6a1.5 1.5 0 0 0 2 2l6-6a4 4 0 0 0 5.4-5.4l-2.3 2.3-2-2z"></path>','In-house service centre'],
    ['<path d="M4 5h13a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H9l-5 4z"></path>','Expert advice — call us']
  ];
  function trust(){
    var btn=atcAny(); if(!btn)return;
    var b=btn.closest('.pd3__purchase')||btn;
    var host=b.parentNode; if(!host||host.querySelector('.mc-trust'))return;
    var el=document.createElement('div'); el.className='mc-trust';
    el.innerHTML=TRUST.map(function(t){return '<span class="mc-trust__i">'+icon(t[0])+'<span>'+t[1]+'</span></span>';}).join('');
    host.insertBefore(el,b.nextSibling);
  }

  /* ---------------- C. sticky mobile add to cart ---------------- */
  function sticky(){
    if(!PROD||document.querySelector('.mc-sticky'))return;
    var m=metaP();
    var bar=document.createElement('div'); bar.className='mc-sticky';
    var avail=PROD.available;
    bar.innerHTML='<img src="'+fixImg(PROD.featured_image)+'" alt="">'+
      '<span class="mc-sticky__i"><span class="mc-sticky__t">'+esc(PROD.title)+'</span><span class="mc-sticky__p">'+money(PROD.price)+'</span></span>'+
      '<button type="button" class="mc-sticky__btn">'+(avail?'Add to cart':'Order in')+'</button>';
    document.body.appendChild(bar);
    bar.querySelector('.mc-sticky__btn').addEventListener('click',function(){
      if(PROD.available){var r=realATC(); if(r){r.click();} else {window.scrollTo({top:0,behavior:'smooth'});}}
      else{location.href='/pages/contact';}
    });
    /* re-query the live add-to-cart each check so template re-renders don't strand us */
    var ticking=false;
    function upd(){
      ticking=false;
      var t=atcAny(); var show;
      if(t){var r=t.getBoundingClientRect(); show=(r.bottom<8)||(r.top>window.innerHeight-8);}
      else{show=true;}
      bar.classList.toggle('is-on',show);
    }
    var last=0,tid;
    function onScroll(){var now=Date.now(); if(now-last>90){last=now;upd();} else {clearTimeout(tid);tid=setTimeout(function(){last=Date.now();upd();},90);}}
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',onScroll);
    upd();
  }

  /* ---------------- D. cross-sell row ---------------- */
  function crosssell(){
    if(document.querySelector('.mc-xs'))return;
    var m=metaP(); var pid=m&&m.id; if(!pid)return;
    if(document.querySelector('.mc-xs'))return;
    var mark=document.createElement('div'); mark.className='mc-xs'; mark.style.display='none'; document.body.appendChild(mark); /* reserve to avoid double */
    fetch('/recommendations/products.json?product_id='+pid+'&limit=4&intent=related').then(function(r){return r.json();}).then(function(d){
      var ps=(d.products||[]).slice(0,4);
      if(ps.length<3){mark.remove();return;}
      var sec=document.createElement('section'); sec.className='mc-xs';
      sec.innerHTML='<div class="mc-xs__wrap"><h2 class="mc-xs__h">You might also like</h2><div class="mc-xs__grid">'+ps.map(function(p){
        return '<a class="mc-xs__card" href="'+p.url.split('?')[0]+'"><span class="mc-xs__imgw"><img src="'+fixImg(p.featured_image||(p.images&&p.images[0]))+'" alt="" loading="lazy"></span><span class="mc-xs__t">'+esc(p.title)+'</span><span class="mc-xs__p">'+money(p.price)+'</span></a>';
      }).join('')+'</div></div>';
      var footer=document.querySelector('.shopify-section-group-footer-group');
      if(footer&&footer.parentNode){footer.parentNode.insertBefore(sec,footer);}
      else{(document.querySelector('main')||document.body).appendChild(sec);}
      mark.remove();
    }).catch(function(){mark.remove();});
  }

  /* ---------------- E. back-in-stock / order-in capture ---------------- */
  function capture(){
    var panel=document.querySelector('.mc-orderin'); if(!panel)return;
    if(panel.querySelector('.mc-bis')||panel.querySelector('.mc-bis__ok'))return;
    var wrap=panel.querySelector('.t')||panel;
    var cta=panel.querySelector('.mc-orderin__cta');
    var form=document.createElement('form'); form.className='mc-bis';
    form.innerHTML='<input type="email" required placeholder="Your email" aria-label="Your email"><button type="submit">Notify me &amp; order in</button>';
    if(cta){cta.style.display='none'; cta.parentNode.insertBefore(form,cta);} else {wrap.appendChild(form);}
    form.addEventListener('submit',function(e){
      e.preventDefault();
      var input=form.querySelector('input'); var email=(input.value||'').trim();
      if(!email||email.indexOf('@')<1)return;
      var m=metaP();
      try{
        window._learnq=window._learnq||[];
        window._learnq.push(['identify',{'$email':email}]);
        window._learnq.push(['track','Requested Order In',{
          ProductName:(PROD&&PROD.title)||document.title,
          Handle:(m&&m.handle)||'',
          URL:location.href.split('?')[0],
          Price:PROD?PROD.price/100:undefined,
          Vendor:(m&&m.vendor)||''
        }]);
      }catch(err){}
      try{
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=SsZ52u',{
          method:'POST',keepalive:true,
          headers:{'Content-Type':'application/json','revision':'2024-10-15'},
          body:JSON.stringify({data:{type:'subscription',attributes:{custom_source:'Order-In form',profile:{data:{type:'profile',attributes:{email:email,subscriptions:{email:{marketing:{consent:'SUBSCRIBED'}}}}}}},relationships:{list:{data:{type:'list',id:'WG9RKg'}}}}})
        });
      }catch(err){}
      var ok=document.createElement('div'); ok.className='mc-bis__ok';
      ok.innerHTML='✓ Thanks — we’ll be in touch to arrange your order-in and confirm the lead time.';
      form.parentNode.replaceChild(ok,form);
    });
  }

  /* ---------------- run ---------------- */
  function tickReactive(){ finance(); trust(); capture(); }
  function initOnce(){ sticky(); crosssell(); }

  if(onProduct){
    getProduct().then(function(){
      initOnce(); tickReactive();
      var mo=new MutationObserver(function(){tickReactive();});
      mo.observe(document.documentElement,{childList:true,subtree:true});
      document.addEventListener('shopify:section:load',function(){initOnce();tickReactive();});
      document.addEventListener('change',tickReactive);
    });
  }
})();
